import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, from, of, throwError } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';
import { Constants } from '../_main/helpers/constant';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    public router: Router,
    private notification: NotificationService,
    private ngZone: NgZone
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(of(this.auth.getTokenValue())).pipe(
      switchMap((token) => {
        let requestClone = null;
        //// console.log('AuthInterceptor ' + token);
        if (token) {
          let serviceCategory = this.auth.getServiceCategory();
          let currency = this.auth.getCurrency();
          let eventId = this.auth.getEventId();

          const venue = localStorage.getItem(Constants.venue);
          let headers = request.headers.set('Authorization', 'Bearer ' + token);
          if (serviceCategory) {
            headers = headers.set('serviceCategoryId', serviceCategory.Id);
          }
          if (eventId) {
            headers = headers.set('eventId', eventId);
          }

          if (currency) {
            headers = headers.set('currencyId', currency.CurrencyId);
          }
          if (venue) {
            headers = headers.set(
              'EcommerceSupplierId',
              JSON.parse(venue)?.SupplierId
            );
          }
          requestClone = request.clone({
            headers,
          });
        }
        return next.handle(requestClone !== null ? requestClone : request).pipe(
          tap(
            (event: HttpEvent<any>) => event,
            (error: any) => {
              if (error.error instanceof ErrorEvent) {
              } else {
                switch (error.status) {
                  case 403: {
                    // this.ngZone.run(() => {
                    //   this.router.navigate(['/error'], {
                    //     queryParams: { error: 403 },
                    //   });
                    // });
                    this.notification.showError(
                      'Access denied. Please check your permissions '
                    );
                    break;
                  }
                  case 0: {
                    this.notification.showError('Please check your connection');
                    break;
                  }
                  case 401: {
                    if (this.auth.isHandling401) break;

                    if (error.error && error.error.Value) {
                      this.notification.showError(error.error.Value);
                    } else {
                      this.notification.showError(
                        'Unauthorized Access: Please check your credentials and try again.'
                      );
                    }
                    this.auth.clearAuthState();
                    this.ngZone.run(() => {
                      this.router.navigate(['/']);
                    });
                    break;
                  }
                  case 400: {
                    break;
                  }
                  case 412: {
                    if (error.error.Error) {
                      this.notification.showError(error.error.Error);
                    } else {
                      this.notification.showError(error.statusText);
                    }
                    break;
                  }
                  case 404: {
                    if (error.error && error.error.Value) {
                      this.notification.showError(error.error.Value);
                    } else {
                      this.notification.showError(error.statusText);
                    }
                    this.ngZone.run(() => {
                      this.router.navigate(['/error'], {
                        queryParams: { error: 404 },
                      });
                    });
                    break;
                  }
                  case 500: {
                    if (!error.error.Error)
                      this.ngZone.run(() => {
                        this.router.navigate(['/error'], {
                          queryParams: { error: 500 },
                        });
                      });
                    break;
                  }
                  default: {
                    if (!navigator.onLine) {
                      this.notification.showError('No internet connection');
                      break;
                    }
                    this.notification.showError(error.message);
                    break;
                  }
                }
              }
              return throwError(() => error);
            }
          )
        );
      })
    );
  }
}

export function errorHandler(error: HttpErrorResponse) {
  if (error instanceof HttpErrorResponse) {
    if (error.status !== 200 && error.status !== 400) {
      /* this.router.navigate(['ErrorPage']); */
      // return;
    }
    const error1 = throwError(error);
    return error1;
  }
  return null;
}
